(function(){
  var body = document.body;
  if (!body || !body.classList.contains('template-cart')) return;

  var mobileMQ = window.matchMedia('(max-width: 767.98px)');
  var selector = '.es-cart-mobile-sticky-checkout';
  var pending = false;

  function clearAdjusted(){
    document.querySelectorAll('[data-es-cart-mobile-float-adjusted="1"]').forEach(function(el){
      var originalBottom = el.getAttribute('data-es-cart-mobile-float-bottom');
      if (originalBottom === null || originalBottom === '') {
        el.style.removeProperty('bottom');
      } else {
        el.style.setProperty('bottom', originalBottom);
      }
      el.removeAttribute('data-es-cart-mobile-float-adjusted');
      el.removeAttribute('data-es-cart-mobile-float-bottom');
    });
  }

  function runAdjust(){
    pending = false;
    clearAdjusted();

    if (!mobileMQ.matches) return;

    var sticky = document.querySelector(selector);
    if (!sticky) return;

    var stickyRect = sticky.getBoundingClientRect();
    if (!stickyRect || !stickyRect.height) return;

    var minBottom = Math.max(148, Math.round(window.innerHeight - stickyRect.top + 42));
    var nodes = document.body.querySelectorAll('*');


    var knownFloatSelectors = [
      '#shopify-chat',
      '#shopify-chat-dummy',
      '#dummy-chat-button-iframe',
      'inbox-online-store-chat',
      '.shopify-chat',
      '[data-shopify-chat]',
      'iframe[src*="chat.shopify"]',
      'iframe[title*="chat" i]',
      'button[aria-label*="chat" i]',
      'a[aria-label*="chat" i]'
    ];

    knownFloatSelectors.forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){
        if (!el || el === sticky || (sticky.contains && sticky.contains(el))) return;
        if (el.closest && el.closest('.footer_v4')) return;
        var style = window.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity || '1') === 0) return;
        el.setAttribute('data-es-cart-mobile-float-bottom', el.style.bottom || '');
        el.style.setProperty('bottom', minBottom + 'px', 'important');
        el.setAttribute('data-es-cart-mobile-float-adjusted', '1');
      });
    });

    Array.prototype.forEach.call(nodes, function(el){
      if (!el || el === sticky || sticky.contains(el)) return;
      if (el.id === 'back-to-top' || el.closest && el.closest('#back-to-top')) return;
      if (el.closest && el.closest('.footer_v4')) return;

      var style = window.getComputedStyle(el);
      if (style.position !== 'fixed') return;
      if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity || '1') === 0) return;

      var rect = el.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      if (rect.top < 90) return;
      if (rect.width > 240 || rect.height > 240) return;
      if (rect.right < window.innerWidth - 160) return;
      if (rect.bottom < stickyRect.top - 18) return;

      var computedBottom = parseFloat(style.bottom);
      if (isNaN(computedBottom) || computedBottom >= minBottom) return;

      el.setAttribute('data-es-cart-mobile-float-bottom', el.style.bottom || '');
      el.style.setProperty('bottom', minBottom + 'px', 'important');
      el.setAttribute('data-es-cart-mobile-float-adjusted', '1');
    });
  }

  function scheduleAdjust(){
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(runAdjust);
  }

  document.addEventListener('DOMContentLoaded', scheduleAdjust);
  window.addEventListener('load', function(){
    scheduleAdjust();
    window.setTimeout(scheduleAdjust, 500);
    window.setTimeout(scheduleAdjust, 1500);
    window.setTimeout(scheduleAdjust, 3000);
    window.setTimeout(scheduleAdjust, 5000);
  });
  window.addEventListener('resize', scheduleAdjust, { passive: true });
  window.addEventListener('orientationchange', scheduleAdjust, { passive: true });

  var observer = new MutationObserver(scheduleAdjust);
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
})();
